import { createMuiTheme, createPalette } from 'material-ui/styles'
import { lightGreen, red } from 'material-ui/colors'
import { identity } from './brand'


const theme = createMuiTheme({
  brand: identity,
  palette: {
    primary: {
      light: '#005795',
      main: '#1C408C',
      dark: '#1F2532',
      contrastText: '#fff',
    },
    secondary:{
      light: '#FF7043',
      main: '#FF7043',
      dark: '#FF7043',
      contastText: '#FF7043'
    },
    accent: '#FF7043',
    success: '#4caf50',
    fail: '#ff5252',
  },
  overrides: {
    MuiButton: {
      raisedAccent: {
        color: 'white',
      },
      raisedPrimary: {
        color: 'white',
      },
    },
  }
})

export default theme



// WEBPACK FOOTER //
// ./src/themes/ideal/default.theme.js